var _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 59,
    width: 51,
    height: 49,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 155,
    height: 155,
    rx: 77.5,
    stroke: "#FA382F",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_16_101",
    transform: "scale(0.0196078 0.0204082)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_16_101",
    width: 51,
    height: 49,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAAC9ElEQVRoBe2ZvYsTQRTAU/uJnfgBFlYWfnBIyL6XI4Lmdt7mzsbaE7WwsDgVK/HjD/DEQ+y1sLQQOxHriAhWFtqp2dnduxwKgqBCZHOZuNmb3bw1CdmVCSyzM/Pey/vtzHszs1sq9X6rp2CPJHgsCTvdS2DLs+GC6i9MKR1YlAQ/+iAKqFtC86uDuwoB84Wso3qI3ggRdlyCp4WAkQIeDYMJ+9v12f25B3IJPnFgJFnncg8jCdocGM+xbhQABl9zYAJhnck9jGvDleEwsO7V61tzDxM66RK+TwMq1Hqz1qjslQRNDdC3cORyPyI6B6UoH/LJut0ivOMJPK+TMW3mCfwHT6AlZo/JBtZ8UQVp1w5kQgoVOVewUDmYZJijH8q0RW1f3EZAx3f7Am5KAc8kga9JQh0prLfSqT7w5/BIXH+grlUe2DVvbDhdsu4PKPYqqwuwnW3DgSVlI9yJewT3uLpKrkX4XPdQunaV0LDSJVxRjkTL9ZMzO4fpqn6V5j3CsiQMVHvmUsBaYANG/RgLTFuUd3CdcR1YCubQloQ/uTopcr+kAycGgFKEN06cvSmXNM2CWm0b3waucGV5cvA9PI/1gXhK4QFt9Jjh/lc2OXjzDzCjx0w2J/+edIfp9Xf0wwRV/zgSgLI1gfLVWBJAlmw2AQgV17/d+ZktJe4fTCRmuoshLKpF1yO46BJ+4PoUlfMaOD81GI+s0/3Ajd34TvVW1FHOvS/w2lRgAhso5v+mqiTrIQciIrM8DZjlTZ4nNEin+jHirIoPbekSPBkZJsuiGTqW5f2bFHCZD4MvMsCMY52BZsIgaJs/2+XDXBjpWC8zwIxhB+BYd7VepzTmF8aG6yl+a7vYqTrbyIw+zfwGXtV6nNLoEr5jjY6BiT3FLNsZMzJmmmleYkQDbxxHADPNzDQz06xUMqk5tlalVc0OIJqGdfcmNceSillnzDoTmxLxuClEzIRfljlX+CkiKYVy9EMZ37YqSTaS2l2CSxz7UuDZP5YlqbJ4d01JAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRed);
export default __webpack_public_path__ + "static/media/linkedinRed.dacce17de1fd8ff8f83b8ec1dad38304.svg";
export { ForwardRef as ReactComponent };